import React, { createContext, useCallback, useContext } from 'react'
import Keycloak from 'keycloak-js'

type KeycloakCtx = {
  keycloak: Keycloak
  logout?: () => Promise<void>
}
export const KeycloakContext = createContext<KeycloakCtx>({
  keycloak: {} as Keycloak,
  logout: undefined
})

export const KeycloakProvider = ({
  keycloak,
  logout,
  children
}: KeycloakCtx & { children: React.ReactNode }) => {
  const handleLogout = useCallback(async () => {
    try {
      keycloak.onAuthLogout?.()
      await logout?.()
    } catch (error) {
      console.error(error)
    }
  }, [logout, keycloak])
  return (
    <KeycloakContext.Provider value={{ keycloak, logout: handleLogout }}>
      {children}
    </KeycloakContext.Provider>
  )
}

export const useKeycloak = () => useContext(KeycloakContext)
